import { PopulationInlineChoice } from './../shared/interfaces/';

export class FillInTheBlankTileTextEvaluator {
  static isCorrect(
    population: PopulationInlineChoice,
    userAnswers: string[]
  ): boolean {
    const [userAnswersInText, correctAnswersInText] =
      this._constructUserAndCorrectAnswersInText(population, userAnswers);
    return (
      userAnswers.length === population.answers.length &&
      userAnswersInText.every(
        (answerText, i) =>
          correctAnswersInText[i].toLowerCase() === answerText.toLowerCase()
      )
    );
  }

  static getWrongAnswers(
    population: PopulationInlineChoice,
    userAnswers: string[]
  ): string[][] {
    const wrong: string[][] = [];
    const [userAnswersInText, correctAnswersInText] =
      this._constructUserAndCorrectAnswersInText(population, userAnswers);
    for (let i = 0; i < userAnswersInText.length; i += 1) {
      if (
        userAnswersInText[i]?.toLowerCase() !==
        correctAnswersInText[i]?.toLowerCase()
      ) {
        wrong[i] = [userAnswers[i]];
      } else {
        wrong[i] = [];
      }
    }
    return wrong;
  }

  static _constructUserAndCorrectAnswersInText(
    population: PopulationInlineChoice,
    userAnswers: string[]
  ): Array<string[]> {
    const answerChoicesMap: { [key: string]: string } = {};
    population.answerChoices.forEach(answerChoice => {
      if (answerChoice.id)
        answerChoicesMap[answerChoice.id] = answerChoice.choice.texts?.[0]
          .text as string;
    });
    const userAnswersInText = userAnswers.map(answerId => {
      if (answerChoicesMap[answerId]) {
        return answerChoicesMap[answerId];
      }
      return answerId;
    });
    const correctAnswersInText = population.answers.map(answerId => {
      if (answerChoicesMap[answerId]) {
        return answerChoicesMap[answerId];
      }
      return answerId;
    });
    return [userAnswersInText, correctAnswersInText];
  }
}
